/** Limiti durata video (secondi) - allineati a gym_social_video.php su server. */
export const VIDEO_MAX_SEC_DEFAULT = {
  story: 60,
  reel: 90,
  post: 300,
};

/**
 * @param {File} file
 * @returns {Promise<number>}
 */
export function readVideoFileDuration(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      URL.revokeObjectURL(url);
      const d = video.duration;
      if (!Number.isFinite(d) || d <= 0) {
        reject(new Error('Durata video non leggibile'));
        return;
      }
      resolve(d);
    };
    video.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Impossibile leggere il video'));
    };
    video.src = url;
  });
}

/**
 * @param {number} durationSec
 * @param {'post'|'story'|'reel'} contentType
 * @param {Record<string, number>} [limits]
 */
export function validateVideoDuration(durationSec, contentType, limits = VIDEO_MAX_SEC_DEFAULT) {
  const max = limits[contentType] ?? limits.post ?? 300;
  const min = contentType === 'reel' ? 3 : 1;
  if (durationSec < min) {
    throw new Error(`Video troppo corto (min ${min} s)`);
  }
  if (durationSec > max) {
    throw new Error(`Video troppo lungo (max ${max} s)`);
  }
  return Math.round(durationSec * 10) / 10;
}
